import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import StyledTypography, { StyledRequiredSymbol } from './Typography.styles.js';

const Typography = forwardRef((props, ref) => {
    const { children, as = "span" } = props, restProps = __rest(props, ["children", "as"]);
    if (!children)
        return null;
    return (jsxs(StyledTypography, Object.assign({}, restProps, { as: as, ref: ref }, { children: [children, (props === null || props === void 0 ? void 0 : props.required) ? (jsx(StyledRequiredSymbol, { children: "*" })) : null] })));
});

export { Typography as default };
//# sourceMappingURL=Typography.js.map
